export default "__VITE_ASSET__C6a$T9yn__"